export type WoodworkProject = {
  readonly id: string
  readonly title: string
  readonly description: string
  readonly status: 'in-progress' | 'planned' | 'complete'
  readonly materials?: string
}

export type LabProject = {
  readonly id: string
  readonly title: string
  readonly description: string
  readonly path: string
  readonly tag: string
}

export const bio = {
  name: 'Tristan J. Hall',
  tagline: 'Woodworker · Maker · Tinkerer',
  intro:
    'I build things with my hands — furniture, shop fixtures, and whatever the next project demands. This site is my workshop journal and portfolio: pieces I am proud of, works in progress, and the occasional side experiment that has nothing to do with sawdust.',
  about: [
    'Most of my time goes to the shop: measuring twice, chasing square, and learning from every joint that does not quite close. I care about honest materials, clean lines, and furniture that earns a place in a home for decades.',
    'When I am not at the bench, you will find small tools and apps here too — like a recipe parser I wrote because copy-pasting ingredients from cooking sites was driving me up the wall.'
  ]
} as const

export const woodworkProjects: WoodworkProject[] = [
  {
    id: 'coming-soon-1',
    title: 'Portfolio pieces',
    description:
      'Project photos and write-ups will land here as builds finish. Each entry will cover design intent, materials, and lessons from the build.',
    status: 'planned'
  },
  {
    id: 'coming-soon-2',
    title: 'Shop & fixtures',
    description:
      'Workbenches, storage, and shop organization — the infrastructure that makes everything else possible.',
    status: 'planned',
    materials: 'Hard maple, plywood, hardware'
  },
  {
    id: 'coming-soon-3',
    title: 'Furniture',
    description:
      'Tables, seating, and casework built for real rooms — documented from rough lumber through finish.',
    status: 'planned'
  }
]

export const labProjects: LabProject[] = [
  {
    id: 'recipe-parser',
    title: 'Recipe Parser',
    description:
      'Paste a URL from Epicurious, Bon Appétit, or NYT Cooking and get a clean, printable recipe — no ads, no clutter.',
    path: '/lab/recipe-parser',
    tag: 'Utility'
  }
]
